module.exports = __webpack_public_path__ + "img/icon_wrong.b0b9778b.svg";